import ArrowDown from "../../assets/images/baseIcons/arrow-down.svg";
import ArrowRight from "../../assets/images/baseIcons/arrow-right.svg";
import ArrowLeft from "../../assets/images/baseIcons/arrow-left.svg";
import Instagram from "../../assets/images/baseIcons/instagram.svg";
import Facebook from "../../assets/images/baseIcons/facebook.svg";
import X from "../../assets/images/baseIcons/x.svg";
import Edit from "../../assets/images/baseIcons/edit.svg";
import Trash from "../../assets/images/baseIcons/trash.svg";
import Filter from "../../assets/images/baseIcons/filter.svg";
import Search from "../../assets/images/baseIcons/search.svg";
import Web from "../../assets/images/baseIcons/web.svg";
import Linkedin from "../../assets/images/baseIcons/linkedin.svg";
import CopyLink from "../../assets/images/baseIcons/copy-link.svg";
import Eye from "../../assets/images/baseIcons/eye.svg";
import Sort from "../../assets/images/baseIcons/sort.svg";
import Download from "../../assets/images/baseIcons/download.svg";

function BaseIcon(props: BaseIconProps) {
	function getIconByEnum(iconEnum) {
		switch (iconEnum) {
			case "arrow-down":
				return ArrowDown;
			case "arrow-right":
				return ArrowRight;
			case "arrow-left":
				return ArrowLeft;
			case "instagram":
				return Instagram;
			case "facebook":
				return Facebook;
			case "x":
				return X;
			case "edit":
				return Edit;
			case "trash":
				return Trash;
			case "filter":
				return Filter;
			case "search":
				return Search;
			case "web":
				return Web;
			case "linkedin":
				return Linkedin;
			case "copy-link":
				return CopyLink;
			case "eye":
				return Eye;
			case "sort":
				return Sort;
			case "download":
				return Download;
			default:
				return ArrowDown;
		}
	}

	function getAltByEnum(iconEnum: BaseIconEnum) {
		switch (iconEnum) {
			case "arrow-down":
				return "arrow-down";
			case "arrow-right":
				return "arrow-right";
			case "arrow-left":
				return "arrow-left";
			case "instagram":
				return "instagram";
			case "facebook":
				return "facebook";
			case "x":
				return "x";
			case "edit":
				return "edit";
			case "trash":
				return "trash";
			case "filter":
				return "filter";
			case "search":
				return "search";
			case "web":
				return "web";
			case "linkedin":
				return "linkedin";
			case "copy-link":
				return "copy-link";
			case "eye":
				return "eye";
			case "sort":
				return "sort";
			case "download":
				return "download";
			default:
				return "arrow-down";
		}
	}

	return (
		<img
			className={props.className}
			src={getIconByEnum(props.icon)}
			alt={getAltByEnum(props.icon)}
			height={20}
			width={20}
			style={props.styles}
		/>
	);
}

export default BaseIcon;
